// colors
export const BLUE = '#0176d5'
export const LIGHT_BLUE = '#c9e6ff'

// borders
export const BLUE_BORDER = `1px solid ${BLUE}`
export const GREY_BORDER = '1px solid #e8edf0'
